import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DynamicForm } from "../DynamicForm";
import Datas from "../../utils/householdQuestions.json";
import { SelectLocationDropdown } from "../SelectLocationDropdown";

type QuestionItem = {
  question: string;
  answer: string | null;
};

type CategoryItem = {
  category: string;
  questions: QuestionItem[];
};
type Location = {
  aimag: string;
  sum: string;
  bag: string;
};
export const HouseHoldPage = () => {
  const [location, setLocation] = useState<Location | null>(null);
  const [currentCategory, setCurrentCategory] = useState<string>("location");
  const [selectedAimag, setSelectedAimag] = useState<string>("");
  const [selectedSum, setSelectedSum] = useState<string>("");
  const [selectedBag, setSelectedBag] = useState<string>("");
  const [questions, setQuestions] = useState<CategoryItem[] | null>(null);

  const handlePreviousCate = () => {
    if (currentCategory === "backgroundInfo") {
      setCurrentCategory("location");
    } else if (currentCategory === "fireSafe") {
      setCurrentCategory("backgroundInfo");
    } else if (currentCategory === "prepare") {
      setCurrentCategory("fireSafe");
    } else if (currentCategory === "safeWay") {
      setCurrentCategory("prepare");
    }
  };
  const handleNext = () => {
    if (questions !== null) {
      if (selectedBag !== "" && currentCategory === "location") {
        setCurrentCategory("backgroundInfo");
      } else if (
        currentCategory === "backgroundInfo" &&
        questions[0].questions.every((e) => e.answer != null)
      ) {
        setCurrentCategory("fireSafe");
      } else if (
        currentCategory === "fireSafe" &&
        questions[1].questions.every((e) => e.answer != null)
      ) {
        setCurrentCategory("prepare");
      } else if (
        currentCategory === "prepare" &&
        questions[2].questions.every((e) => e.answer != null)
      ) {
        setCurrentCategory("safeWay");
      }
    }
  };
  const sendAnswer = () => {
    if (questions !== null) {
      if (questions[3].questions.every((e) => e.answer != null)) {
        return location;
      }
    }
  };
  useEffect(() => {
    setQuestions(Datas as CategoryItem[]);
  }, []);
  useEffect(() => {
    setLocation({
      aimag: selectedAimag,
      sum: selectedSum,
      bag: selectedBag,
    });
  }, [selectedBag, selectedSum, selectedAimag]);

  // Helper to determine progress width
  const getProgressWidth = () => {
    switch (currentCategory) {
      case "location":
        return "w-1/5";
      case "backgroundInfo":
        return "w-2/5";
      case "fireSafe":
        return "w-3/5";
      case "prepare":
        return "w-4/5";
      case "safeWay":
        return "w-full";
      default:
        return "w-full";
    }
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 py-6 sm:py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="mb-6">
          <Link
            to="/forum"
            className="inline-flex items-center text-gray-600 hover:text-amber-600 transition-colors font-medium bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100"
          >
            ← Буцах
          </Link>
        </div>

        <div className="bg-white rounded-2xl overflow-hidden border border-gray-100">
          <div className="px-4 py-6 sm:px-10 bg-amber-500 text-white text-center">
            <h1 className="text-sm sm:text-xl font-bold leading-relaxed">
              Хуулийн этгээд, аж ахуйн нэгж, байгууллага гамшгийн бэлэн байдлаа
              шалгах хяналтын хуудас
            </h1>
          </div>

          <div className="px-6 py-8 sm:px-10">
            {/* Progress Bar */}
            <div className="w-full h-3 bg-gray-100 rounded-full mb-8 overflow-hidden">
              <div
                className={`${getProgressWidth()} bg-amber-500 h-full rounded-full transition-all duration-500 ease-out`}
              />
            </div>

            {/* Step Content */}
            {currentCategory === "location" && (
              <div className="space-y-6 animate-fadeIn">
                <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-amber-100 text-amber-600 text-sm font-bold">
                      1
                    </span>
                    Өрхийн мэдээлэл
                  </h3>
                  <SelectLocationDropdown
                    setSelectedAimag={setSelectedAimag}
                    selectedAimag={selectedAimag}
                    setSelectedSum={setSelectedSum}
                    selectedSum={selectedSum}
                    setSelectedBag={setSelectedBag}
                    selectedBag={selectedBag}
                  />
                </div>
              </div>
            )}

            {questions && (
              <div className="animate-fadeIn">
                {currentCategory === "backgroundInfo" && (
                  <div className="space-y-4">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b">
                      Ерөнхий мэдээлэл
                    </h3>
                    <DynamicForm
                      categoryData={questions[0]}
                      setAllCategories={setQuestions}
                    />
                  </div>
                )}
                {currentCategory === "fireSafe" && (
                  <div className="space-y-4">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b">
                      Галын аюулгүй байдал
                    </h3>
                    <DynamicForm
                      categoryData={questions[1]}
                      setAllCategories={setQuestions}
                    />
                  </div>
                )}
                {currentCategory === "prepare" && (
                  <div className="space-y-4">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b">
                      Бэлэн байдал
                    </h3>
                    <DynamicForm
                      categoryData={questions[2]}
                      setAllCategories={setQuestions}
                    />
                  </div>
                )}
                {currentCategory === "safeWay" && (
                  <div className="space-y-4">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b">
                      Аюулгүй зам
                    </h3>
                    <DynamicForm
                      categoryData={questions[3]}
                      setAllCategories={setQuestions}
                    />
                  </div>
                )}
              </div>
            )}

            {/* Navigation Buttons */}
            <div className="mt-10 pt-6 border-t border-gray-100 flex justify-between items-center">
              {currentCategory !== "location" ? (
                <button
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    handlePreviousCate();
                  }}
                  className="px-6 py-2.5 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-xl font-semibold transition-colors"
                >
                  Өмнөх
                </button>
              ) : (
                <div></div>
              )}

              {currentCategory === "safeWay" ? (
                <button
                  onClick={sendAnswer}
                  className="px-6 py-2.5 bg-green-600 text-white shadow-lg shadow-green-200 hover:bg-green-700 rounded-xl font-semibold transition-all transform hover:-translate-y-0.5"
                >
                  Хариултыг илгээх
                </button>
              ) : (
                <button
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    handleNext();
                  }}
                  className="px-6 py-2.5 bg-amber-500 text-white shadow-lg shadow-amber-200 hover:bg-amber-600 rounded-xl font-semibold transition-all transform hover:-translate-y-0.5"
                >
                  Дараах
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
